<template>
  <div>
    <b-form-group label="Period" label-for="category">
      <b-form-input id="category" v-model="category" type="text" required placeholder="Enter Name"
        :state="errors && !errors.category"></b-form-input>
      <b-form-invalid-feedback v-if="errors && errors.category">
        {{ errors.category }}
      </b-form-invalid-feedback>
    </b-form-group>


    <div v-for="(card, cardIndex) in cards" :key="cardIndex" class="mb-3">
      <b-card>
        <b-row>
          <!-- Name -->
          <b-col cols="12" md="6" lg="2">
            <b-form-group label="Name" label-for="name-input">
              <b-form-input id="name-input" v-model="card.columns[0].name" type="text" placeholder="Enter Name"
                :state="errors[cardIndex] && !errors[cardIndex].name" required></b-form-input>
              <b-form-invalid-feedback v-if="errors[cardIndex] && errors[cardIndex].name">
                {{ errors[cardIndex].name }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <!-- Q1-Q4 Budget/Actual -->
          <b-col v-for="(col, colIndex) in card.columns.slice(1, 5)" :key="'col-' + cardIndex + '-' + colIndex"
            cols="12" md="6" lg="2" class="mb-2">
            <div><strong>Q{{ colIndex + 1 }}</strong></div>

            <b-form-group label="Budget">
              <b-form-input v-model.number="col.budget" type="number" placeholder="Enter Budget"
                :state="!getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Budget')" required
                @input="updateTotal(cardIndex)"></b-form-input>
              <b-form-invalid-feedback v-if="getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Budget')">
                {{ getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Budget') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Actual">
              <b-form-input v-model.number="col.actual" type="number" placeholder="Enter Actual"
                :state="!getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Actual')" required
                @input="updateTotal(cardIndex)"></b-form-input>
              <b-form-invalid-feedback v-if="getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Actual')">
                {{ getFieldError(cardIndex, 'q' + (colIndex + 1) + 'Actual') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>


          <!-- Y Total -->
          <b-col cols="12" md="6" lg="2">
            <div><strong>Y</strong></div>
            <b-form-group label="Budget">
              <b-form-input v-model="card.columns[5].budget" type="number" readonly></b-form-input>
            </b-form-group>
            <b-form-group label="Actual">
              <b-form-input v-model="card.columns[5].actual" type="number" readonly></b-form-input>
            </b-form-group>
          </b-col>

          <!-- Remove -->
          <b-col cols="12" md="6" lg="2">
            <b-button variant="danger" class="mt-4" @click="deleteCard(cardIndex)" block>
              Remove
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="addCard">Add</b-button>
    </div>
    <div class="text-right mt-3">
      <b-button variant="primary" @click="submitBudget">Save</b-button>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
  },
  data() {
    return {
      category: "",
      cards: [
        {
          columns: [
            { name: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" },
            { budget: "", actual: "" }, // Y - calculated
          ],
        },
      ],
      errors: [{}],
    };
  },
  methods: {
    ...mapActions("budgetModule", ["postBudgetAction"]),

    getFieldError(cardIndex, fieldKey) {
      return this.errors[cardIndex]?.[fieldKey] || null;
    },

    updateTotal(cardIndex) {
      const card = this.cards[cardIndex];
      card.columns[5].budget = card.columns.slice(1, 5).reduce((sum, col) => sum + (col.budget || 0), 0);
      card.columns[5].actual = card.columns.slice(1, 5).reduce((sum, col) => sum + (col.actual || 0), 0);
    },

    addCard() {
      this.cards.push({
        columns: [
          { name: "" },
          { budget: "", actual: "" },
          { budget: "", actual: "" },
          { budget: "", actual: "" },
          { budget: "", actual: "" },
          { budget: "", actual: "" },
        ],
      });
      this.errors.push({});
    },

    deleteCard(cardIndex) {
      if (this.cards.length > 1) {
        this.cards.splice(cardIndex, 1);
        this.errors.splice(cardIndex, 1);
      } else {
        Swal.fire({
          title: "Error",
          text: "Cannot delete the last card!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },

    async submitBudget() {
      let hasError = false;
      this.errors = [];

      this.cards.forEach((card, index) => {
        const cardErrors = {};
        if (!card.columns[0].name) {
          cardErrors.name = "Name is required";
          hasError = true;
        }

        card.columns.slice(1, 5).forEach((col, colIndex) => {
          if (col.budget === null || col.budget === "") {
            cardErrors[`q${colIndex + 1}Budget`] = "Budget is required";
            hasError = true;
          }
          if (col.actual === null || col.actual === "") {
            cardErrors[`q${colIndex + 1}Actual`] = "Actual is required";
            hasError = true;
          }
        });

        this.errors.push(cardErrors);
      });

      if (!this.category) {
        //Swal.fire("Error", "Period is required!", "warning");
        this.errors.category = "Period is required";
        hasError = true;
        return;
      }

      if (hasError) {
        Swal.fire("Error", "Please fix all validation errors.", "warning");
        return;
      }

      const budgetSum = this.cards.reduce((sum, card) => sum + card.columns[5].budget, 0);
      const actualSum = this.cards.reduce((sum, card) => sum + card.columns[5].actual, 0);

      const payload = {
        actualAmount: budgetSum,
        budgetAmount: actualSum,
        budgetDetails: this.cards.map((card) => ({
          name: card.columns[0].name,
          q1: parseFloat(card.columns[1]?.budget || 0),
          q1V: parseFloat(card.columns[1]?.actual || 0),
          q2: parseFloat(card.columns[2]?.budget || 0),
          q2V: parseFloat(card.columns[2]?.actual || 0),
          q3: parseFloat(card.columns[3]?.budget || 0),
          q3V: parseFloat(card.columns[3]?.actual || 0),
          q4: parseFloat(card.columns[4]?.budget || 0),
          q4V: parseFloat(card.columns[4]?.actual || 0),
          y: parseFloat(card.columns[5]?.budget || 0),
          yv: parseFloat(card.columns[5]?.actual || 0),
        })),
        category: this.category || "DEFAULT",
      };

      try {
        Swal.fire({
          title: "Processing...",
          text: "Please wait while we save the budget data.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await this.postBudgetAction(payload);
        Swal.close();

        if (response && response.success) {
          Swal.fire({
            title: "Success",
            text: "Budget added successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            this.$router.push("/accounting-budget");
          });
        } else {
          Swal.fire("Error", "Failed to add budget. Please try again.", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Failed to add budget. Please try again.", "error");
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.mb-2 {
  margin-bottom: 0.5rem;
}
</style>
